module.exports = __webpack_public_path__ + "static/apple-touch-icon-114x114-02c77e69975e7f41a742e9ff0e58e313.png";